/**
 * mcycle homepage header search box module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import './searchBox.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Arrow from '../../../../svgs/arrow';
import { Link } from 'react-router-dom';
import history from '../../../../routes/history';
import { getSearchTip } from '../../../../actions/search';

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // handle search input change, get input value
  onInputChange = (event) => {
    const { getSearchTip } = this.props;
    const value = event.target.value;

    this.setState({ value: value });
    if (value) setTimeout(function() { getSearchTip(value) }, 100);
  }

  handleKeyUp = (e) => {
    const value = this.state.value;
    if (e.keyCode === 13 && value) {
      history.push(`/view/search?q=${value}`);
    }
  }

  render() {
    const value = this.state.value;
    const { flowList, searchTip, pageInfo } = this.props;
    const isShowTip = value && searchTip && searchTip.length;
    const fontColor = pageInfo.frontConfig.textRgb ? {color: pageInfo.frontConfig.textRgb} : {};

    return (
      <div className="mcycle-home-fixed-box">
        <ul className="mcycle-home-flow-list clearfix">
          {
            flowList.map((item, index) => {
              if (index % 2) {
                return <li className="mcycle-flow-to" key={ index }>
                  <Arrow /><Arrow /><Arrow />
                </li>
              } else {
                return <li className="mcycle-flow-step" key={ index }>
                  <div className="mcycle-flow-cycle">{ item.title }</div>
                  <p className="mcycle-header-font-color" style={ fontColor }>{ item.text }</p>
                </li>
              }
            })
          }
        </ul>
        <div className="mcycle-home-search-box" onKeyUp={ this.handleKeyUp }>
          <input 
            className="mcycle-search-input" 
            type="text" 
            placeholder="请输入需回收的机型型号" 
            maxLength="50" 
            onChange={ this.onInputChange }/>
          <Link to={{ pathname: '/view/search', search: `q=${value || '魅族'}` }}>
            <button className="mcycle-search-btn">搜索</button>
          </Link>
        </div>
        <ul className="mcycle-search-tips-list" style={{display: isShowTip ? 'block' : 'none'}}>
          {
            searchTip.map((item, index) => (
              <Link to={{ pathname: '/view/search', search: `q=${item.name}` }} key={ index }>
                <li className="search-tips-select">{ item.name }</li>
              </Link>
            ))
          }
        </ul>
      </div>
    )
  }
}

export default connect(
  state => ({
    searchTip: state.search.searchTip,
    pageInfo: state.home.pageInfo
  }),
  { getSearchTip }
)(SearchBox)


// WEBPACK FOOTER //
// ./src/components/home/header/searchBox/searchBox.js